﻿import React from 'react';
import PropTypes from 'prop-types';

import Wysiwyg from 'components/Wysiwyg';

import theme from "./PersonalMessage.module.scss";

const PersonalMessage = ({
  firstName = 'John',
  lastName = 'Doe',
  personalMessage = '',
  onChange,
}) => (
  <div className={theme.personalMessage}>
    <p>
      <strong>{`Personal Message to ${firstName} ${lastName}:`}</strong>
    </p>
    <Wysiwyg defaultValue={personalMessage} onChange={onChange} />
  </div>
);

PersonalMessage.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  personalMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default PersonalMessage;
